export const startCase = (input: unknown): string => {
  const str = typeof input === 'string' ? input : String(input);
  return str
    .split(/[\s_-]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
